import { Button } from '../Button'

import styles from './OutlineStatusPreview.module.scss'

export function OutlineStatusPreview({ 
  onAction,
  className,
  ctaText,
  message,
  showCta, 
  title,
}) {

  const rootClass = [styles.holder, className].filter(Boolean).join(' ')

  return (
    <div className={rootClass}>
      <div className={styles.info}>
        <div className={styles.header}>{title}</div>
        <div className={styles.comment}>{message}</div>
        
        {showCta && ctaText && onAction && (
          <div className={styles.action}>
            <Button onClick={onAction} cta kind="wide" size="large">
              {ctaText}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}